module.exports = __webpack_public_path__ + "static/media/insight.1861a024.png";